import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MaterialModule } from '../../../../shared/patterns/material-module';
import { IOutreachEmail } from '../../models/outreach-email.models';

type ExtraData = { senderEmail: string; templateName: string };

export interface IOutreackEmailSummary extends IOutreachEmail, ExtraData {}

@Component({
  selector: 'app-outreach-email-confirmation',
  templateUrl: './outreach-email-confirmation.component.html',
  styleUrls: ['./outreach-email-confirmation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MaterialModule, DatePipe],
})
export class OutreachEmailConfirmationComponent {
  private readonly emailSummary =
    inject<IOutreackEmailSummary>(MAT_DIALOG_DATA);

  get email(): IOutreachEmail['email'] & ExtraData {
    return {
      ...this.emailSummary.email,
      senderEmail: this.emailSummary.senderEmail,
      templateName: this.emailSummary.templateName,
    };
  }
}
